// Recupera os dados de autenticacao.
export const getAuthParams = () => {
	return {
		accessToken: localStorage.getItem("token"),
		clientId: localStorage.getItem("clientid")
	};
};

// Verifica se existe valor.
export const hasValue = value => {
	return value !== undefined && value !== null && value !== "";
};